import * as NavigationMenu from "@radix-ui/react-navigation-menu";
import Header from "./Header";
import LogoContainer from "./LogoContainer";
import SignInTryItFreeWrapper from "../../SignInTryItFree/signIn-try-free-wrapper";
import UnderlineAnimation from "../../Animations/UnderlineAnimation";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";
import { menuItems } from "../NavData";
import { PrimaryNavBuilderType } from "src/assets/Types/Redesign/PrimaryNavMenuType.type";

const DesktopNavBar: React.FC<PrimaryNavBuilderType> = ({
  onClickHandler,
  noSticky,
  hiddenDesktop = false,
}) => {
  const NavViewport = motion(NavigationMenu.Viewport);

  return (
    <>
      <Header
        className={`bg-white desktop-view ${
          hiddenDesktop && "hidden"
        } md:hidden`}
        noSticky={noSticky}
      >
        <div className="flex items-center gap-[48px] container-primary-nav">
          <LogoContainer onClick={onClickHandler} />
          <NavigationMenu.Root className="bg-inherit items-center">
            <NavigationMenu.List className="m-0 flex items-center gap-6 pl-0">
              {menuItems.map(MenuItem => (
                <NavigationMenu.Item
                  key={MenuItem.component.name}
                  style={{ width: MenuItem.width }}
                  className="border-none pb-[5px] relative list-none"
                >
                  <UnderlineAnimation>
                    <MenuItem.component
                      {...MenuItem.props}
                      onClickHandler={onClickHandler}
                    />
                  </UnderlineAnimation>
                </NavigationMenu.Item>
              ))}

              <NavigationMenu.Item className="border-none pb-[5px] relative list-none">
                <UnderlineAnimation>
                  <NavigationMenu.Link
                    onClick={e => onClickHandler(e, { category: "pricing" })}
                    className="body--text-regular group-hover:font-semibold no-underline text-forest-900"
                    href="/pricing/"
                  >
                    Pricing
                  </NavigationMenu.Link>
                </UnderlineAnimation>
              </NavigationMenu.Item>
            </NavigationMenu.List>
            <div className="perspective-[2000px] absolute mt-[26px] left-0 flex w-full justify-center z-50 shadow-sticky-nav">
              <AnimatePresence mode="wait" initial={false}>
                <NavViewport
                  // forceMount
                  className="data-[state=open]:animate-expandHeight data-[state=closed]:animate-collapseHeight relative w-full origin-[top_center] overflow-hidden bg-white transition-[width,_height] duration-300 h-[var(--radix-navigation-menu-viewport-height)]"
                />
              </AnimatePresence>
            </div>
          </NavigationMenu.Root>
        </div>
        <SignInTryItFreeWrapper onClickHandler={onClickHandler} />
      </Header>
    </>
  );
};

export default DesktopNavBar;
